import React from 'react';

const Projects = () => {
  const projects = [
    {
      title: "Chromaflow",
      description: "Music-visualization app syncing audio with shader animations to create visuals that respond to tempo and emotional tone.",
      github: "https://github.com/znobunaga",
      demo: "https://chromaflow-ten.vercel.app/",
    },
    {
      title: "UCR Purity",
      description: "4000+ users. Interactive quiz platform delivering personalized results with real-time analytics and secure authentication.",
      github: "https://github.com/znobunaga",
      demo: "https://ucr-purity.vercel.app/",
    },
    {
      title: "Lokl",
      description: "Social media app helping users discover, plan, and share real-world experiences with friends.",
    },
  ];

  return (
    <section id="projects" className="py-4 bg-background text-bone-white md:pl-6 pl-2">
      <div className="px-3 lg:px-6 xl:px-8 2xl:px-10 text-left">
        <h2 className="text-4xl font-bold mb-6">Selected Projects</h2>
        
        {projects.map((project, index) => (
          <div key={index} className="mb-6">
            {project.demo ? (
              <a href={project.demo} target="_blank" rel="noopener noreferrer" className="text-bone-white hover:text-blue-400 transition-colors">
                <h3 className="text-xl font-semibold mb-2">{project.title}</h3>
              </a>
            ) : (
              <h3 className="text-xl font-semibold mb-2">{project.title}</h3>
            )}
            <div className="code-tag" data-before="<div>" style={{ fontSize: '14px', color: 'blue' }}></div>
            <div className="text-description max-w-xl xl:max-w-2xl 2xl:max-w-3xl mb-2">
              {project.description}
            </div>
            <div className="code-tag" data-after="</div>" style={{ fontSize: '14px', color: 'blue' }}></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
